import React from "react";

interface ListToolbarProps {
  children: React.ReactNode;
  resultCount?: number;
  resultLabel?: string;
  className?: string;
}

/** Layout shell for a list page's search + filters + result count row.
 * Wraps on small screens instead of forcing the page into horizontal scroll
 * independent of the table below it. */
export default function ListToolbar({ children, resultCount, resultLabel = "results", className }: ListToolbarProps) {
  return (
    <div className={`flex flex-wrap items-center gap-3 mb-6 ${className ?? ""}`}>
      {children}
      {resultCount !== undefined && (
        <span className="text-xs text-muted-foreground font-inter ml-auto whitespace-nowrap">
          {resultCount} {resultLabel}
        </span>
      )}
    </div>
  );
}
